import React from 'react';
import Button from '@mui/material/Button';
import SettingsIcon from '@mui/icons-material/Settings';
import {useSelector, useDispatch} from 'react-redux';
import { toggleDrawer, togglePlaying, setTextToDisplay, toggleAbout} from '../settings-panel/store/settingsSlice';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import createCwTrainer from '../../app/classes/factories';
import InfoIcon from '@mui/icons-material/Info';

function AppMenu(props) {

    const isPlaying = useSelector((state) => state.settings.isPlaying);
    const wpm = useSelector((state) => state.settings.wpm);
    const farnsworthWpm = useSelector((state) => state.settings.farnsworthWpm);
    const totalCharRepeats = useSelector((state) => state.settings.totalCharRepeats);
    const display = useSelector((state) => state.settings.display);
    const type = useSelector((state) => state.settings.type);
    const useLetters = useSelector((state) => state.settings.useLetters);
    const useNumbers = useSelector((state) => state.settings.useNumbers);
    const useSymbols = useSelector((state) => state.settings.useSymbols);

    const dispatch = useDispatch();

    const handlePlay = () => {
        dispatch(togglePlaying());    
        window.cwPlayer = createCwTrainer(type, wpm, 
            farnsworthWpm, useLetters, useNumbers, useSymbols, 
            totalCharRepeats, display , (character) => dispatch(setTextToDisplay(character)));
        window.cwPlayer.play();
    };

    const handleStop = () => {
        dispatch(togglePlaying());
        if(window.cwPlayer != null) window.cwPlayer.stop();        
        dispatch(setTextToDisplay(``));
    };

    return (
        <ul className="list-reset flex justify-center flex-1 md:flex-none items-center text-white">

            {isPlaying && <li className="m-4">
                <Button
                    disabled={!isPlaying}
                    variant="contained"
                    onClick={handleStop}
                >
                    <StopCircleOutlinedIcon/>
                </Button>
            </li>}
            {(!isPlaying) && <li className="m-4">
                <Button
                    variant="contained"
                    onClick={handlePlay}
                >
                    <PlayCircleOutlineIcon/>
                </Button>
            </li>}
            <li className="m-4">
                <Button
                    variant="contained"
                    onClick={() => dispatch(toggleDrawer())}
                >
                    <SettingsIcon/>
                </Button>
            </li>
            <li className="m-4">
                <Button
                    variant="contained"
                    onClick={() => dispatch(toggleAbout())}
                >
                    <InfoIcon/>
                </Button>
            </li>
        </ul>
    );
}

export default AppMenu;